import React from 'react';
import { Root } from './style';

import { useSiteData } from 'utils';
import { useDashboard } from 'dashboard';
import { useWeb3 } from 'web3';

const Addresses = () => {
  const {
    addresses,
    removeWalletAddress,
    selectWalletAddress,
    deselectWalletAddress,
  } = useDashboard();

  const { wallet, disconnect } = useWeb3();

  const selectAddress = (address, select) => {
    (select ? selectWalletAddress : deselectWalletAddress)(address);
  };

  const { projectWallets } = useSiteData().resources;

  const publicTags = projectWallets.reduce((tags, { address, name }) => {
    tags[address] = name;
    return tags;
  }, {});

  const removeWallet = (address) => {
    removeWalletAddress(address);
    wallet &&
      wallet.account.toLowerCase() === address.toLowerCase() &&
      disconnect();
  };

  return (
    <Root>
      <ul>
        {Object.entries(addresses.get()).map(([address, selected]) => (
          <li
            key={address}
            className={selected ? 'selected' : ''}
            onClick={() => selectAddress(address, !selected)}
          >
            {publicTags[address] || address}
            <span
              className="remove"
              onClick={() => removeWallet(address)}
            ></span>
          </li>
        ))}
      </ul>
    </Root>
  );
};

export default Addresses;
